import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../../componentes/header/header';
import FinalComponent from '../../../componentes/EndPage/Final';
import homeData from './traducao.json';  // traduções da página Membros
import squad1 from './squad1.json';
import squad2 from './squad2.json';
import squad3 from './squad3.json';
import squad4 from './squad4.json';
import squad5 from './squad5.json';
import squad6 from './squad6.json';
import squad7 from './squad7.json';
import nodeMulti from './nodeMulti.json';
import CardSlider from '../../../componentes/membrosCarrossel/CardSlider';
import CompFundadores from "../../../componentes/Fundadores/Fundadores";
import jsonDataFundadores from '../../HomePage/fundadores.json';  // fundadores da HomePage
import homeDataCoordenadores from '../../HomePage/traducao.json';  // traduções coordenadores da HomePage

const Membros = () => {
  const [language, setLanguage] = useState(localStorage.getItem("siteLanguage") || 'pt');
  const [translation, setTranslation] = useState(homeData['pt']);
  const [fundadoresDataLang, setFundadoresDataLang] = useState(jsonDataFundadores['pt']);
  const [coordenadoresDataLang, setCoordenadoresDataLang] = useState(homeDataCoordenadores['pt']);

  useEffect(() => {
    setTranslation(homeData[language] || homeData['pt']);
    setFundadoresDataLang(jsonDataFundadores[language] || jsonDataFundadores['pt']);
    setCoordenadoresDataLang(homeDataCoordenadores[language] || homeDataCoordenadores['pt']);
  }, [language]);

  useEffect(() => {
    const browserLanguage = navigator.language.split('-')[0];
    const supportedLanguages = ['pt', 'en', 'es'];
    const savedLang = localStorage.getItem("siteLanguage");

    if (!savedLang) {
      if (supportedLanguages.includes(browserLanguage)) {
        setLanguage(browserLanguage);
        localStorage.setItem("siteLanguage", browserLanguage);
      } else {
        setLanguage('pt');
        localStorage.setItem("siteLanguage", 'pt');
      }
    }
  }, []);

  const handleLanguageChange = (newLang) => {
    setLanguage(newLang);
    localStorage.setItem("siteLanguage", newLang);
  };

  const generoClass = "text-[30px] text-[#B040B1] inline-block relative font-extrabold my-8 max-[1500px]:mt-[8%] max-[768px]:mt-[20%] max-[768px]:text-[24px] max-[480px]:mt-[40%]";
  const generoAfter = (
    <span
      className="absolute left-[-25%] bottom-[-1px] w-[150%] h-[45px] z-[-20] rounded-[50px] shadow-[5px_5px_10px_rgba(0,0,0,0.2)] max-[768px]:left-[-10%] max-[768px]:w-[120%] max-[768px]:h-[35px]"
      style={{
        background: "linear-gradient(to right, rgba(106, 13, 173, 0.4), rgba(255, 102, 178, 0.4))"
      }}
      aria-hidden="true"
    />
  );

  return (
    <div>
      <Header handleLanguageChange={handleLanguageChange} />
      <Helmet>
        <title>{translation.page_title || 'Membros | Sobrevidas ACS'}</title>
      </Helmet>

      <h3 className={generoClass}>
        {coordenadoresDataLang?.our_coordinators || "Nossos Coordenadores"}
        {generoAfter}
      </h3>

      <CompFundadores data={fundadoresDataLang} />

      <h2 className={generoClass}>
        {translation.squad1 || 'Squad 1 — Negócio'}
        {generoAfter}
      </h2>
      <div>
        <CardSlider membros={squad1[language]} language={language} />
      </div>

      <h2 className={generoClass}>
        {translation.squad2 || 'Squad 2 — QA e Testes'}
        {generoAfter}
      </h2>
      <div>
        <CardSlider membros={squad2[language]} language={language} />
      </div>

      <h2 className={generoClass}>
        {translation.squad3 || 'Squad 3 — Backend e Dados'}
        {generoAfter}
      </h2>
      <div>
        <CardSlider membros={squad3[language]} language={language} />
      </div>

      <h2 className={generoClass}>
        {translation.squad4 || 'Squad 4 — Frontend e Mobile'}
        {generoAfter}
      </h2>
      <div>
        <CardSlider membros={squad4[language]} language={language} />
      </div>

      <h2 className={generoClass}>
        {translation.squad5 || 'Squad 5 — IA (Automação)'}
        {generoAfter}
      </h2>
      <div>
        <CardSlider membros={squad5[language]} language={language} />
      </div>

      <h2 className={generoClass}>
        {translation.squad6 || 'Squad 6 — Visão Computacional'}
        {generoAfter}
      </h2>
      <div>
        <CardSlider membros={squad6[language]} language={language} />
      </div>

      <h2 className={generoClass}>
        {translation.squad7 || 'Squad 7 — Modelagem Clínica'}
        {generoAfter}
      </h2>
      <div>
        <CardSlider membros={squad7[language]} language={language} />
      </div>

      <h2 className={generoClass}>
        {translation.nodeMulti || 'Node eMulti'}
        {generoAfter}
      </h2>
      <div>
        <CardSlider membros={nodeMulti[language]} language={language} />
      </div>

      <div className="max-[768px]:mt-[10em]">
        <FinalComponent />
      </div>
    </div>
  );
};

export default Membros;
